document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined" && document.querySelector("[data-quick-links]")) {
    let quicklinksSwiperLoopDone = false;
    const quicklinksSwiper = new Swiper("[data-quick-links]", {
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesOffsetBefore: 8,
      slidesOffsetAfter: 8,
	    centeredSlides: false, 
      freeMode: {
        enabled: false,
        sticky: true, // smooth free scroll, no snap
      }, 
      pagination: {
        el: ".swiper-pagination",  // Progress bar container
        type: "progressbar",
      },
      on: {
        init: function () {
          handleSwiperResize(this); 
        }
      }, 
    });

    // Restart autoplay on resize (mobile only)
    quicklinksSwiper.on("resize", () => {
      handleSwiperResize(quicklinksSwiper); 
    });
  }
});


function handleSwiperResize(swiper) {
  const wrapper = swiper.el.querySelector(".swiper-wrapper");
  const containerWidth = swiper.el.clientWidth;
  const slidesWidth = Array.from(wrapper.children)
    .reduce((total, slide) => total + slide.offsetWidth, 0);


  if (slidesWidth > containerWidth) {
    swiper.el.classList.remove("is-not-scrollable");
  } else {
    swiper.el.classList.add("is-not-scrollable");
  }
}